import * as Accordion from './accordion'
import Alert from './alert'
import Badge from './badge'
import Box from './box'
import Button from './button'
import Checkbox from './checkbox'
import * as FormControl from './formControl'
import Heading from './heading'
import Input from './input'
import Link from './link'
import * as Modal from './modal'
import Radio from './radio'
import Skeleton from './skeleton'
import * as Slider from './slider'
import Spinner from './spinner'
import Text from './text'
import TextArea from './textarea'

export default {
  Alert,
  ...Accordion,
  Badge,
  Button,
  Checkbox,
  ...FormControl,
  Heading,
  Box,
  Input,
  Link,
  ...Modal,
  Radio,
  Skeleton,
  ...Slider,
  Spinner,
  Text,
  TextArea,
}
